<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>新增管理</el-breadcrumb-item>
        <el-breadcrumb-item>销售管理</el-breadcrumb-item>
        <el-breadcrumb-item>销售看板</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 头部用户人数显示 -->
    <el-row :gutter="24">
      <el-col :span="8">
        <el-card class="box-card">
          <div class="userList">
            <p class="user">本月销售收入总额</p>
            <p class="number">{{XiaoShouTotalShouRuMonth}}</p>
          </div>
        </el-card>
      </el-col>

      <el-col :span="8">
        <el-card class="box-card">
          <div class="userList">
            <p class="user">本年销售收入总额</p>
            <p class="number">{{XiaoShouTotalShouRuYear}}</p>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="24">
      <el-col :span="12">
        <el-card class="box-card">
          <div class="card_title">本年销售金额---柱状图</div>
          <ve-histogram :data="XiaoShouYearList" :extend="trainingExtend" :legend-visible="false" :colors="trainingColors"></ve-histogram>
        </el-card>
      </el-col>

      <el-col :span="12">
        <el-card class="box-card">
          <div class="card_title">本年销售金额占比---饼状图</div>
          <ve-pie :data="XiaoShouProjectList" :legend-visible="true"></ve-pie>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="24">
      <el-col :span="12">
        <el-card class="box-card">
          <div class="card_title">本年销售金额---列表</div>
          <!-- 数据列表 start -->
          <el-table :data="XiaoShouYearListRows" ref="XiaoShouYearListRows" :cell-style="{padding: '0'}" border height="360">
            <el-table-column prop="Month" label="月份" min-width="25%"></el-table-column>
            <el-table-column prop="Moneys" label="金额" min-width="25%"></el-table-column>
          </el-table>
          <!-- 数据列表 end -->
        </el-card>
      </el-col>

      <el-col :span="12">
        <el-card class="box-card">
          <div class="card_title">本年销售金额占比---列表</div>
          <!-- 数据列表 start -->
          <el-table :data="XiaoShouProjectListRows" ref="XiaoShouProjectListRows" :cell-style="{padding: '0'}" border height="360">
            <el-table-column prop="Name" label="名称" min-width="25%"></el-table-column>
            <el-table-column prop="Moneys" label="金额" min-width="25%"></el-table-column>
          </el-table>
          <!-- 数据列表 end -->
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="24">
      <el-col :span="24">
        <el-card class="box-card">
          <div class="card_title">本月销售明细---列表</div>
          <!-- 数据列表 start -->
          <el-table :data="SaleDetailsList" ref="SaleDetailsList" :row-class-name="tableRowClassName" :cell-style="{padding: '0'}" border height="360">
            <el-table-column prop="ClassificationName" label="分类" width="100"></el-table-column>
            <el-table-column prop="ProjectName" label="项目名称" width="200"></el-table-column>
            <el-table-column prop="TotalXiaoShouNums" label="销售数量（套）" width="130"></el-table-column>
            <el-table-column prop="TotalXiaoShouDanJias" label="平均销售单价" width="120"></el-table-column>
            <el-table-column prop="TotalXiaoShouJinEs" label="合同金额" width="100"></el-table-column>
            <el-table-column prop="TotalYesJinEs" label="已收金额" width="100"></el-table-column>
            <el-table-column prop="TotalNoJinEs" label="未收金额" width="100"></el-table-column>
          </el-table>
          <!-- 数据列表 end -->
        </el-card>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  name: 'MyErp6SaleSignboard',
  data () {
    // 训练数据反馈表
    this.trainingExtend = {
      series (v) {
        v.forEach(i => {
          i.barWidth = 20
        })
        return v
      }
    }
    return {
      XiaoShouTotalShouRuMonth: 0,
      XiaoShouTotalShouRuYear: 0,
      XiaoShouYearList: {
        columns: ['Month', 'Moneys'],
        rows: []
      },
      XiaoShouYearListRows:[],
      XiaoShouProjectList: {
        columns: ['Name', 'Moneys'],
        rows: []
      },
      XiaoShouProjectListRows:[],
      SaleDetailsList: [],
      trainingColors: ['#4ad2ff']
    }
  },
  mounted () {
    this.apiErp6SaleSignboard()
  },
  methods: {
    tableRowClassName({row, rowIndex}) {
      if(row.MaterialName == '小计'){
        return 'success-row';
      }
      return '';
    },
    apiErp6SaleSignboard: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Erp6SaleSignboard, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.XiaoShouTotalShouRuMonth = response.data.XiaoShouTotalShouRuMonth
          that.XiaoShouTotalShouRuYear = response.data.XiaoShouTotalShouRuYear
          that.XiaoShouYearList.rows = response.data.XiaoShouYearList
          that.XiaoShouYearListRows = response.data.XiaoShouYearList
          that.XiaoShouProjectList.rows = response.data.XiaoShouProjectList
          that.XiaoShouProjectListRows = response.data.XiaoShouProjectList
          that.SaleDetailsList = response.data.SaleDetailsList
          console.log(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style>
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }

</style>

<style lang="less" scoped>
.box-card{
    margin-top: 20px;
    background: #FFF;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.userList{
    display: flex;
    align-items: center;
    .user{
        color:#999;
        margin: 0 20px 0 0;
    }
    .number{
        font-size: 30px;
        margin: 0;
        font-weight: bold;
    }
}

.warntitle{
    //display: flex;
    align-items: center;
    color:#ff0000;
    font-size: 30px;
    margin: 0;
    font-weight: bold;
    text-decoration:underline;
    text-align:center;
}

.card_title{
    font-size: 16px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
}

</style>
